import Clock from 'react-live-clock';
import React from 'react';
import PropTypes from 'prop-types';
export const RealClock = ({obj}) =>{
	return(
		<>
			<Clock format={'HH:mm:ss a'} ticking={true} timezone={'Asia/Hong_Kong'} />
		</>
	)

}
RealClock.propTypes = {
	obj: PropTypes.object
};
